<ion-header [translucent]="true">
	<ion-toolbar class="payment-header">
		<div class="ion-text-wrap">
			<ion-title mode="md">{{ 'selectPaymentMethod.title' | translate }}</ion-title>
		</div>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="payment-content">
	<!-- Payment Methods (hidden when gift cards fully cover the check) -->
	@if (!giftCardsFullyCoverCheck) {
		<ion-radio-group [value]="selectedPaymentMethod">
			<ion-list lines="none">
				@for (m of filteredPaymentMethods; track m) {
					<ion-item (click)="selectMethod(m)" [button]="true" [detail]="false" class="method-item">
						<ion-radio [value]="m" slot="start"></ion-radio>
						<ion-label>{{ label(m) }}</ion-label>
						@if (label(m)) {
							<img [src]="icon(m)" alt="" class="method-icon {{ m }}" slot="end" />
						}
					</ion-item>
				}
			</ion-list>
		</ion-radio-group>
	}

	<!-- Gift Card Section -->
	@if (supportsGiftCards) {
		<div class="gift-cards-section">
			<ion-row class="ion-justify-content-between ion-align-content-center">
				<div class="gift-cards-header">{{ 'selectPaymentMethod.giftCards' | translate }}</div>
				<ion-icon (click)="addGiftCard()" class="gift-card-add-icon" name="add-circle-outline"></ion-icon>
			</ion-row>

			@if (addedGiftCards.length > 0) {
				@for (card of addedGiftCards; track card.hash) {
					<div class="gift-card">
						<div class="gift-card-info">
							<div class="gift-card-number">{{ card.hash }}</div>
							<div class="gift-card-balance">{{ formattedCardBalance(card) }}</div>
						</div>
						<ion-button (click)="removeGiftCard(card.hash)" color="danger" fill="clear" size="small">
							<ion-icon name="trash-outline"></ion-icon>
						</ion-button>
					</div>
				}

				<div class="gift-card-summary">
					<div class="summary-row">
						<span>{{ 'selectPaymentMethod.giftCardBalance' | translate }}</span>
						<span class="balance-value">{{ formattedGiftCardBalance }}</span>
					</div>
					@if (giftCardsFullyCoverCheck) {
						<div class="summary-row fully-covered">
							<span>{{ 'selectPaymentMethod.fullyCovered' | translate }}</span>
						</div>
					} @else {
						<div class="summary-row remaining">
							<span>{{ 'selectPaymentMethod.remainingBalance' | translate }}</span>
							<span>{{ formattedRemaining }}</span>
						</div>
					}
				</div>
			}
		</div>
	}

	<p [innerHTML]="'selectPaymentMethod.hint' | translate" class="home-hint ion-padding ion-text-center ion-margin-horizontal"></p>
</ion-content>

<ion-footer class="payment-footer">
	<div class="separator"></div>

	<app-pay-session-statistics
		[paySessionStatistics]="paySessionStatistics"
		[remainingAmount]="totalGiftCardBalance > 0 ? remainingAfterGiftCards : null"
		[showChecks]="true"
		[showSelected]="true"
		[showTable]="true"
		[showTips]="true"
		[showTotal]="true"
	/>

	@if (giftCardsFullyCoverCheck) {
		<ion-button (click)="confirmSelection()" color="primary" expand="block">
			{{ 'selectPaymentMethod.payWithGiftCard' | translate }}
		</ion-button>
	} @else {
		<ion-button (click)="confirmSelection()" [disabled]="!canConfirm" color="primary" expand="block">
			{{ 'common.continue' | translate }}
		</ion-button>
	}
</ion-footer>
